module.exports = __webpack_public_path__ + "img/lion-travel.40672f2c.png";